// ActualizarAreascontrolcambiosPage.tsx


// import { useFetchGetByIdAreascontrolcambios } from "@/shared/actions/auditoria/Areascontrolcambios.actions";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { UsuariosSistemaGET } from '@/shared/interfaces';
import { useTableFilter } from '@/shared/hooks/useTableFilter';
import {
useTableServerSideFiltering,
} from '@/shared/hooks';
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
} from '@/shared';
import { useFetchUsuariosSistema } from '@/shared/actions/erp/administration/usuarios';

import { useColumnsUsuarioSistema } from '@/erp/administration/usuarios/shared/hooks';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import { useState } from "react";
import { ModalAsignarAreaAprobador } from "../../components/modal-asignar-area-aprobador";

import { useAuthStore } from "@/store/auth/auth.store"; 
import { useUserModulesStore } from "@/store/auth";       
import { SystemModulesEnum } from "@/auth/interfaces";
import { Outlet } from "react-router-dom";

export default function AprobadorescontrolcambiosPage() {
    const user = useAuthStore((s) => s.user) as any; 
    const userModules = useUserModulesStore((s) => s.modules);  
    const isSuper = !!user?.is_superuser || !!user?.is_staff; 
    const tineAccesoAreacontrolAreas = userModules.includes(SystemModulesEnum.CONTROL_CAMBIOS_APROBADORES)   
  
  
  const returnURL = ROUTER_PATHS.control_cambios.aprobadorareanav;

      // server side filters - colums table
    const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
    const [usuarioSeleccionado, setUsuarioSelecionado] = useState<UsuariosSistemaGET | null>(null);
    const [modalAsignarOpen, setModalAsignaraOpen] = useState(false);
    const {
        globalFilter,
        pagination,
        searchTerm,
        onChangeFilter,
        setPagination,
        cleanFilter
    } = useTableFilter();
    const { pageIndex, pageSize } = pagination;

    const {
    data: usuariosSistemaPagingRes,
    isLoading,
    isRefetching,
    } = useFetchUsuariosSistema({
        enabled: true,
        params: {
        page: pageIndex + 1,
        page_size: pageSize,
        razon_social: searchTerm,
        ...filterObject,
        },
    });
    const { columnsControlCambiosUser  } = useColumnsUsuarioSistema();
    
    const handleEdit = (original: UsuariosSistemaGET) =>{
      setUsuarioSelecionado(original);
      setModalAsignaraOpen(true);
    }

    if(!isSuper || !tineAccesoAreacontrolAreas){
    return (
    <SingleTableBoxScene
      title="ADMINISTRACIÓN DE APROBADORES"
      enableRedirect={true}
      urlRedirect={`${returnURL}`}
      textRedirect = "Volver"
      iconRedirect={<ArrowBackIcon  />}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        cleanFilter={cleanFilter}
        text="por nombre"
      />


      <GeneralTable<UsuariosSistemaGET>
        columns={columnsControlCambiosUser }
        data={usuariosSistemaPagingRes?.data.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={usuariosSistemaPagingRes?.data?.count}
        ///* filters - server side
        enableSorting={false}
        // crud
        showCustomActionBtnSpace={false}
        enableEditing={true}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
        positionActionsColumn="first"
        enableColumnActions={true}
        canEdit={true}
      
        onEdit={handleEdit}
        canDelete={false}
        
      />
      <ModalAsignarAreaAprobador
        open = {modalAsignarOpen}
        onClose = {() => setModalAsignaraOpen(false)}
        usuario ={usuarioSeleccionado}
      />
    </SingleTableBoxScene>
  );
  }
  return <Outlet />;
}
